import { mostrarIdioma } from '@/utils/utils.js'

export default {
    getProductosListado(state, getters, rootState, rootGetters) {
        let res = [];

        let a = [...state.productosArray, ...state.menus];
        console.log(state.categoriaFiltrar)
        a.filter(a => !!a).forEach(element => {
            let nombreMostrar = !!element.nombre ? mostrarIdioma(element.nombre) : '';
            let descripcionMostrar = !!element.descripcion ? mostrarIdioma(element.descripcion) : '';
            if (state.categoriaFiltrar === null || state.categoriaFiltrar == element.categoria || (state.categoriaFiltrar === 'modificadores' && !!element.modificador) || (state.categoriaFiltrar === 'productos' && !!element.individualPedible) || (state.categoriaFiltrar === 'menus' && !!element.menu)) {
                let cat_a = rootGetters['categorias/getCategoriasSelect'];
                let found = cat_a.find(e => e.value == element.categoria);
                let aux = element;
                if (found)
                    aux.categoriaMostrar = found.text;
                aux.nombreMostrar = nombreMostrar;
                aux.descripcionMostrar = descripcionMostrar;
                res.push(aux);
            }
        });
        return res
            .sort((a, b) => (a.orden > b.orden ? 1 : b.orden > a.orden ? -1 : 0));

    },
    productosListadoTodos(state, getters, rootState, rootGetters) {
        console.log(state.productosArray);
        return [...state.productosArray, ...state.menus].map(element => {
            let nombreMostrar = !!element.nombre ? mostrarIdioma(element.nombre) : '';
            let descripcionMostrar = !!element.descripcion ? mostrarIdioma(element.descripcion) : '';
            let cat_a = rootGetters['categorias/getCategoriasSelect'];
            let found = !!element.categoria ? cat_a.find(e => e.value == element.categoria) : false;
            let aux = element;
            if (found)
                aux.categoriaMostrar = found.text;
            aux.nombreMostrar = nombreMostrar;
            aux.descripcionMostrar = descripcionMostrar;
            return aux;
        });
    },
    getProductosSelect(state) {
        let devolver = [];
        let cOrders = state.productosArray;
        //cOrders = cOrders.sort((a,b) => (a.orden > b.orden) ? 1 : ((b.orden > a.orden) ? -1 : 0)); 
        for (let prd of cOrders) {
            let aux = {
                value: prd.id,
                text: mostrarIdioma(prd.nombre)
            }
            devolver.push(aux);
        }
        return devolver;
    },
}